/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { FixedSizeList } from 'react-window';
import AutoSizer, { Size } from 'react-virtualized/dist/commonjs/AutoSizer';
import { Box, CircularProgress } from '@mui/material';
import { usePath } from 'hookrouter';
import { useAppSelector } from '../../hooks';
import { PageContentCard } from '../library/PageContentCard';
import { UsersCard } from './UsersCard';
import { GroupMember } from '../../types/GroupMember';
import { AppRoutes } from '../../constants/AppRoutes';

const CARD_HEIGHT = 188;

export const UsersCards: React.FC<{
  filteredUsers: (GroupMember & {
    groupName?: string;
  })[];
}> = ({ filteredUsers }) => {
  const path = usePath();
  const { loading } = useAppSelector((state) => state.group);

  if (loading)
    return (
      <PageContentCard sx={{ height: '140px', width: '100%', textAlign: 'center', placeContent: 'center' }}>
        <CircularProgress style={{ alignSelf: 'center' }} color="secondary" />
      </PageContentCard>
    );

  if (path.startsWith(AppRoutes.Groups)) {
    return (
      <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', mt: '12px' }}>
        <AutoSizer>
          {({ height, width }: Size): JSX.Element => (
            <FixedSizeList
              height={height - 48}
              width={width}
              itemCount={filteredUsers.length}
              itemSize={CARD_HEIGHT + 8}
              itemData={filteredUsers}
            >
              {UsersCard}
            </FixedSizeList>
          )}
        </AutoSizer>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <AutoSizer style={{ marginLeft: '-24px' }}>
        {({ height, width }: Size): JSX.Element => (
          <FixedSizeList
            height={height}
            width={width + 48}
            itemCount={filteredUsers.length}
            itemSize={CARD_HEIGHT + 8}
            itemData={filteredUsers}
          >
            {UsersCard}
          </FixedSizeList>
        )}
      </AutoSizer>
    </Box>
  );
};
